<style>
@import "./index.css";
.tf-pic>div{
    margin-left: 0 !important;
}
</style>

<template>
    <div>
        <Form ref="accountLogin" :model="accountLogin" :rules="accountLoginRule" :label-width="80">
            <FormItem label="头像" prop="pic" class="tf-flex tf-flex-middle tf-pic">
                <div class="tf-flex tf-flex-start">
                    <div id="userphoto">
                        <img class="userphoto-pic" :src="[accountLogin.pic == undefined || accountLogin.pic == '' ? defaultPic : imgSrc+accountLogin.pic]">
                        <img class="userphoto-xj" :src="xj">
                        <input ref="inputer" @change="addImg($event)" type="file" accept="image/*" />
                    </div>
                </div>
            </FormItem>
            <FormItem label="昵称" prop="nickName">
                <Input :maxlength="10" v-model="accountLogin.nickName" clearable placeholder="请输入昵称"></Input>
            </FormItem>
            <FormItem label="时区选择" prop="sqTime">
                <Select v-model="accountLogin.sqTime" style="width:100%">
                    <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                <p>当前时区：{{defaultShiqu}}</p>
            </FormItem>
            <FormItem class="mb5">
                <Button long size="large" :loading="accountLogin.btnLoading" type="primary" @click="handleSubmit('accountLogin')">
                    <span>{{!accountLogin.btnLoading ? '确定' : '修改中...'}}</span>
                </Button>
            </FormItem>
        </Form>

        <!--图片裁剪-->
        <Modal v-model="cropperShow" draggable title="图片裁剪" @on-cancel="onClose" @on-ok="crop">
            <cropper-pic
                ref="cropperDom"
                :aspectratio="1/1"
                :circle="true"
                @setpicurl="setPicUrl"
            ></cropper-pic>
        </Modal>

    </div>
</template>

<script>
import xj from '@/assets/img/tf_xj.png';
import defaultPic from '@/assets/img/type2.png';
import cropperPic from '@/views/cropper';
export default {
    components: {
        cropperPic
    },
    data() {
        return {
            xj:xj,
            defaultPic:defaultPic,
            imgSrc:this.$func.imgSrc,

            //裁剪
            cropperShow:false,

            defaultShiqu:'',

            list: [
                {value: 'UTC-12', label: '埃尼威托克岛, 夸贾林环礁'},
                {value: 'UTC-11',label: '中途岛, 萨摩亚群岛'},
                {value: 'UTC-10',label: '夏威夷'},
                {value: 'UTC-9',label: '阿拉斯加'},
                {value: 'UTC-8',label: '太平洋时间(美国和加拿大), 提华纳'},
                {value: 'UTC-7',label: '山区时间(美国和加拿大), 亚利桑那'},
                {value: 'UTC-6',label: '中部时间(美国和加拿大), 墨西哥城'},
                {value: 'UTC-5',label: '东部时间(美国和加拿大), 波哥大, 利马, 基多'},
                {value: 'UTC-4',label: '大西洋时间(加拿大), 加拉加斯, 拉巴斯'},
                {value: '-3:30',label: '纽芬兰'},
                {value: '-3',label: '巴西利亚, 布宜诺斯艾利斯, 乔治敦, 福克兰群岛'},
                {value: '-2',label: '中大西洋, 阿森松群岛, 圣赫勒拿岛'},
                {value: '-1',label: '亚速群岛, 佛得角群岛'},
                {value: 'UTC',label: '都柏林, 伦敦, 里斯本, 卡萨布兰卡'},
                {value: '+1',label: '柏林, 布鲁塞尔, 哥本哈根, 马德里, 巴黎, 罗马'},
                {value: '+2',label: '开罗, 赫尔辛基, 加里宁格勒, 南非, 华沙'},
                {value: '+3',label: '巴格达, 利雅得, 莫斯科, 奈洛比'},
                {value: '+3:30',label: '德黑兰'},
                {value: '+4',label: '阿布扎比, 巴库, 马斯喀特, 特比利斯'},
                {value: '+4:30',label: '坎布尔'},
                {value: '+5',label: '叶卡特琳堡, 伊斯兰堡, 卡拉奇, 塔什干'},
                {value: '+5:30',label: '孟买, 加尔各答, 马德拉斯, 新德里'},
                {value: '+6',label: '阿拉木图, 科伦坡, 达卡, 新西伯利亚'},
                {value: '+5:45',label: '仰光,加德满都'},
                {value: '+7',label: '曼谷, 河内, 雅加达'},
                {value: '+8',label: '北京, 香港, 帕斯, 新加坡, 台北'},
                {value: '+9',label: '大阪, 札幌, 汉城, 东京, 雅库茨克'},
                {value: '+9:30',label: '阿德莱德, 达尔文'},
                {value: '+10',label: '堪培拉, 关岛, 墨尔本, 悉尼, 海参崴'},
                {value: '+11',label: '马加丹, 新喀里多尼亚, 所罗门群岛'},
                {value: '+12',label: '奥克兰, 惠灵顿, 斐济, 马绍尔群岛'}
            ],

            // +---------------
            // | 输入框数据
            // +---------------
            accountLogin: {
                pic: "",
                nickName:"",
                sqTime:'',
                btnLoading: false
            },

            // +---------------
            // | 验证规则
            // +---------------
            accountLoginRule: {
                nickName: [
                    {required: true, message: "请输入昵称", trigger: "blur"},
                ],
                sqTime: [
                    {required: true, message: "请选择时区", trigger: "change" }
                ]
            }
        }
    },
    computed:{
        userInfo(){
            return this.$store.state.user.userInfo
        }
    },
    watch:{
        userInfo(val){
            val.headImg  ? this.accountLogin.pic      = val.headImg  : '';
            val.nickName ? this.accountLogin.nickName = val.nickName : '';
            val.timeZone ? this.accountLogin.sqTime   = val.timeZone : '';
        }
    },
    created(){
        this.accountLogin = {
            pic     : this.userInfo.headImg,
            nickName: this.userInfo.nickName,
            sqTime  : this.userInfo.timeZone
        }
    },
    methods: {
        //获取默认时区
        getDefaultShiqu(){
            var that = this;
            var lts = that.list;
            //获取当前时区
            that.curShiqu = '';
            var curSQ = new Date().getTimezoneOffset()/60*-1;
            lts.map(function(item,index){
                if(item.value.indexOf(curSQ)>-1){
                    that.defaultShiqu = item.label;
                    that.accountLogin.sqTime = item.value;
                }
            })
        },
        // +---------------
        // | 图片上传裁剪
        // +---------------
        crop(){
            this.$refs.cropperDom.crop();
        },
        onClose(){
            this.cropperShow = false;
        },
        addImg(event)
        {
            let that = this;
            let inputDOM = that.$refs.inputer; //inputDOM.files[0]
            inputDOM = inputDOM.files[0];

            //显示弹出层
            that.cropperShow = true;
            //执行子级方法 添加图片
            that.$refs.cropperDom.addImg(inputDOM);
        },
        setPicUrl(res)
        {
            let that = this;
            that.accountLogin.pic = res;
            that.$func.msg('上传成功');
            that.onClose();
        },

        // +---------------
        // | 提交表单
        // +---------------
        handleSubmit(name) {
            const that = this;
            //验证表单
            that.$refs[name].validate(valid => {
                if (valid)
                {
                    if(that.accountLogin.pic == ''){
                        that.$func.msg('头像必须上传！')
                        return;
                    }
                    that.$func.ajax('updateUserInfo',
                    {
                        token   : that.$func.getToken(),
                        nickName: that.accountLogin.nickName,
                        headImg : that.accountLogin.pic,
                        timeZone: that.accountLogin.sqTime,
                    },function(r){
                        if(!r.statusCode){
                            that.$func.msg(r.message,'error');
                        }else{
                            //按钮状态关闭
                            that[name].btnLoading = false;
                            that.$refs[name].resetFields();
                            that.$func.msg('修改成功！');
                            that.$store.commit("updateUserInfo");
                        }
                    })
                }
            });
        }
    },
    mounted(){
        this.getDefaultShiqu();
    }
};
</script>
